'use es6';

import Immutable from 'immutable';
import { cleanObject } from 'ecosystem-marketplace-core/utils/formatters';
import * as UnreviewableReasons from 'ecosystem-marketplace-core/constants/Reviewability';
const defaults = {
  isPurchased: null,
  maxPortalReviews: 0,
  portalReviewsCount: 0,
  testPortal: null,
  userAlreadyReviewed: null,
  userOnProviderPortal: null
};
export default class ThemeReviewability extends Immutable.Record(defaults) {
  constructor(data) {
    super(cleanObject(data));
  }

  getUnreviewableReason() {
    const {
      isPurchased,
      maxPortalReviews,
      portalReviewsCount,
      testPortal,
      userAlreadyReviewed,
      userOnProviderPortal
    } = this;

    if (!isPurchased) {
      return UnreviewableReasons.NOT_INSTALLED;
    } else if (portalReviewsCount >= maxPortalReviews) {
      return UnreviewableReasons.LIMIT_REACHED;
    } else if (userAlreadyReviewed) {
      return UnreviewableReasons.ALREADY_REVIEWED;
    } else if (userOnProviderPortal) {
      return UnreviewableReasons.PROVIDER_USER;
    } else if (testPortal) {
      return UnreviewableReasons.TEST_PORTAL_USER;
    } else {
      return false;
    }
  }

  isReviewable() {
    return !this.getUnreviewableReason();
  }

}